<template>
    <div class="home">

        <template v-for="(item_value, item) in config.section">
            <slot v-if="item == 'search-bar' & item_value" name="search-bar" />

            <slot v-if="item == 'home-sell-estate' & item_value" name="home-sell-estate" />
            
            <slot v-if="item == 'advertising' & item_value" name="advertising" />

            <!-- <section v-if="item == 'advertising' & item_value" class="advertising" :class="'advertising-' + $root.country">
                <home-advertising />
            </section> -->

            <section v-if="item == 'recent-estates' & item_value & ($root.hasMarketingCookies || (config_cookies && !config_cookies.cookies))">
                <recent-estates
                    :sector="sector == 'can' ? 'construction': 'estate'"
                    :title="trans('titles.recent_estates')"
                />
            </section>

            <slot v-if="item == 'opt-out' & item_value" name="opt-out" />

            <section v-if="item == 'home-services' & item_value" class="home-services">
                <home-services
                    :config="config.services"
                />
            </section>

            <slot v-if="item == 'magazine' & item_value" name="magazine" />

            <section v-if="item == 'home-news' & item_value" class="home-news">
                <div class="container">
                    <home-news
                        :config="config.news"
                    />
                </div>
            </section>
        </template>
    </div>
</template>

<script>
import VueCarousel from 'vue-carousel'
Vue.use(VueCarousel)

// import HomeAdvertising from '../components/HomeAdvertising'
import HomeNews from '../components/HomeNews'
import HomeServices from '../components/HomeServices'
import RecentEstates from '../components/estates/Recent'

export default {
    components: {
        // 'home-advertising': HomeAdvertising,
        'home-news': HomeNews,
        'home-services': HomeServices,
        'recent-estates': RecentEstates,
    },

    props: {
        config: {
            type: Object,
            required: true,
        },

        config_cookies: {
            type: Object,
            required: true,
        },

        sector: {
            type: String,
            required: true,
        },
    },

    computed: {
        lang() {
            return this.$root.lang.home
        },
    },
}
</script>